// §10.6: live loss-reason rollup. Right-rail card. Recomputed from
// the events array on every change — never persisted.

import React from 'react';
import { Card } from '../../../ui';
import { LOSS_REASONS } from '../../../types/pipeline';
import type { OpportunityEvent } from '../../../types/pipeline';
import { computeLossRollup } from './state';

interface Props {
  events: OpportunityEvent[];
}

const DealLossRollup: React.FC<Props> = ({ events }) => {
  const rollup = computeLossRollup(events);
  return (
    <Card padding="default">
      <div className="text-[11px] uppercase tracking-wide text-slate-400 font-mono">
        Loss-reason rollup · live
      </div>
      <div className="text-xs text-slate-400 mt-1.5 mb-3 leading-relaxed">
        Recomputed from the timeline. Reasons accumulate; nothing is
        overwritten.
      </div>
      <ul className="divide-y divide-white/[0.06]">
        {LOSS_REASONS.map((r) => {
          const count = rollup[r];
          const dot = count > 0 ? 'bg-danger' : 'bg-white/[0.16]';
          const value = count > 0 ? 'text-danger-text' : 'text-slate-400';
          return (
            <li key={r} className="flex items-center gap-2 py-1.5">
              <span className={`w-2 h-2 rounded-full ${dot}`} />
              <span className="text-xs flex-1 text-slate-200">{r}</span>
              <span className={`text-xs font-mono ${value}`}>{count}</span>
            </li>
          );
        })}
      </ul>
    </Card>
  );
};

export default DealLossRollup;
